import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { darkTheme, dateZhCN, NConfigProvider, zhCN, NGlobalStyle } from "naive-ui";
import { ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_unref(NConfigProvider), {
    class: "app-content",
    theme: _unref(darkTheme),
    locale: _unref(zhCN),
    "date-locale": _unref(dateZhCN)
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(NGlobalStyle)),
      _createVNode(_component_router_view)
    ]),
    _: 1
  }, 8, ["theme", "locale", "date-locale"]))
}
}

})